import { useCallback } from "react";
import { VariaveisAmbiente } from "../../../../config";

import { useApiBase } from "../../base/api-base";
import { ProcessoProdutoSetorModelNovo } from "../../../../model/api/processo-produto-setor/put-processo-produto-setor";

export function usePutAlterarProcesso() {
    const { invocarApi, ...outrasPropriedades } = useApiBase();

    const putAlterarProcesso = useCallback(
        (alterarProcesso: ProcessoProdutoSetorModelNovo, empresaId: string, proximoProcesso: number) => {
            return invocarApi({
                url: `api/v5/empresa/${empresaId}/processo-produto/alterar-processo/${proximoProcesso}`,
                method: "PUT",
                headers: { "Content-Type": "application/json" },
                data: alterarProcesso,
                baseURL: VariaveisAmbiente.apiSetoresUrl,
                enviarTokenUsuario: true,
            });
        },
        [invocarApi]
    );

    return {
        ...outrasPropriedades,
        putAlterarProcesso,
    };
}